<pos-app-spinner [show]="isLoading$ | async"></pos-app-spinner>
<div class="container">
  <div class="text-center">
    <h3 class="pt-3 arb-large-heading">START NEW ORDER</h3>
  </div>
  <div class="card mt-4">
    <div class="card-body">
      <form [formGroup]="startOrderForm">
        <!-- ShipTo for external users -->
        <div *ngIf="userRole === USER_ROLE.external || userRole === USER_ROLE.programme">
          <div class="row py-2">
            <div class="col-5 col-lg-4">
              <label>ORDER TYPE <span class="text-danger">*</span></label>
            </div>
            <div class="col-7 col-lg-8">
              <ng-select formControlName="orderType" [clearable]="false">
                <ng-option *ngFor="let orderType of orderTypes" [value]="orderType.OrderTypeCode">
                  {{ orderType.OrderTypeDescription }}
                </ng-option>
              </ng-select>
            </div>
          </div>

          <div class="row py-1" *ngIf="preSelectedBillToCustomer && startOrderForm?.controls?.orderType.value === ORDER_TYPE?.arbOrder">
            <div class="col-5 col-lg-4">
              <label class="my-auto d-flex"
                >SELECT CUSTOMER (SHIP TO)
                <mat-icon (click)="addingNewShipToCustomer() && open(content)"> add_circle_outline</mat-icon>
              </label>
            </div>
            <div class="col-7 col-lg-8">
              <ng-select formControlName="shipToNumber" [clearable]="false">
                <!-- <ng-option [value]="ooeUserState?.externalUsersUsualCustomerNumber">
                  {{ preSelectedBillToCustomer.customerName }} ({{ preSelectedBillToCustomer.customerNumber }})
                </ng-option> -->
                <ng-option *ngFor="let customerShipTo of customerShipToList" [value]="customerShipTo.shipToNumber">
                  {{ customerShipTo.shipToName }} ({{ customerShipTo.shipToNumber }})
                </ng-option>
              </ng-select>
            </div>
          </div>

          <div class="row py-2" *ngIf="preSelectedBillToCustomer && startOrderForm?.controls?.orderType.value !== ORDER_TYPE?.arbOrder">
            <div class="col-5 col-lg-4">
              <label class="my-auto d-flex">
                CUSTOMER NAME
                <span class="text-danger">*</span>
                <mat-icon *ngIf="!isGenericQuotesOnlyTF" (click)="addNewCustomer() && open(content)"> add_circle_outline</mat-icon>
              </label>
            </div>
            <div *ngIf="!isGenericQuotesOnlyTF" class="col-7 col-lg-8">
              <pos-app-lib-customer-search
                #customerSearch
                [disabled]="isLoading$ | async"
                [forOrderSearch]="true"
                [selectedCustomerName]="getCustomerName()"
                (selectNewCustomer)="selectShipToCustomer($event)"
                [removeCustomerAfterLoad]="false"
              ></pos-app-lib-customer-search>
            </div>
            <div *ngIf="isGenericQuotesOnlyTF" class="col-7 col-lg-8">
              <input class="form-control" [value]="this.startOrderForm.controls.shipToName?.value" readonly formControlName="shipToName" />
            </div>
          </div>

          <div class="row py-2" *ngIf="startOrderForm.controls.orderType.value === ORDER_TYPE.arbOrder">
            <div class="col-5 col-lg-4">
              <label>ORDER REFERENCE <span *ngIf="isOrderReferenceRequired" style="color: red">*</span></label>
            </div>
            <div class="col-7 col-lg-8">
              <input
                class="form-control"
                formControlName="reference"
                maxlength="25"
                [class.is-invalid]="startOrderForm.get('reference').errors?.invalid"
              />
            </div>
          </div>
          <div
            class="row py-2"
            *ngIf="startOrderForm.controls.orderType.value === ORDER_TYPE.arbOrder"
            [ngClass]="{
              'd-none': startOrderForm.controls.onBehalf.value !== '0'
            }"
          >
            <div class="col-5 col-lg-4">
              <label>BRANCH <span class="text-danger">*</span></label>
            </div>
            <div class="col-7 col-lg-8">
              <ng-select formControlName="dispatchFrom">
                <ng-option *ngFor="let branch of allCombinedBranchesList" [value]="branch.BranchCode">
                  <span class="pr-1" *ngIf="branch.BranchCode">{{ branch.BranchCode }} -</span>
                  {{ branch.BranchDescription }}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div *ngIf="startOrderForm.controls.orderType.value !== ORDER_TYPE.arbOrder">
            <div class="row py-2">
              <div class="col-5 col-lg-4">
                <label>
                  VEHICLE<span
                    class="pl-2 text-danger"
                    (click)="clearVehicle()"
                    *ngIf="selectedCustomerVehicle || vehicleDescription()?.trim().length > 0"
                    >(clear)
                  </span>
                </label>
              </div>
              <div class="col-7 col-lg-8">
                <input type="search" class="form-control" [value]="vehicleDescription()" readonly />
              </div>
            </div>
            <div class="row py-2">
              <div class="offset-3 col-9 offset-lg-4 col-lg-8 justify-content-end d-flex">
                <button
                  *ngIf="preSelectedVehicle || (activeOrderVehicle$ | async) as selectedVehicle"
                  type="button"
                  class="btn btn-secondary text-white"
                  (click)="getSelectedVehicle(selectedVehicle) && open(content)"
                  [disabled]="
                    startOrderForm.controls.customerNumber.value === '' ||
                    !preSelectedVehicle ||
                    (loadingCustomerDetails$ | async) ||
                    (loadingLookupLists$ | async)
                  "
                >
                  USE VEHICLE FROM CATALOGUE
                </button>
                <span class="px-2"></span>
                <button
                  type="button"
                  class="btn btn-secondary text-white"
                  (click)="open(content)"
                  [disabled]="
                    startOrderForm.controls.customerNumber.value === '' || (loadingLookupLists$ | async) || (loadingCustomerDetails$ | async)
                  "
                >
                  SELECT FROM GARAGE
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- ------------------------------------------------------------------- -->
        <!-- ShipTo for external users -->
        <div *ngIf="userRole !== USER_ROLE.external && userRole !== USER_ROLE.programme">
          <div class="row py-1" *ngIf="preSelectedBillToCustomer">
            <div class="col-5 col-lg-4">
              <label class="my-auto">SELECT CUSTOMER (SHIPTO) </label>
            </div>
            <div class="col-7 col-lg-8">
              <ng-select formControlName="shipToNumber" [clearable]="false">
                <ng-option [value]="preSelectedBillToCustomer.customerNumber">
                  {{ preSelectedBillToCustomer.customerName }} ({{ preSelectedBillToCustomer.customerNumber }})
                </ng-option>
                <ng-option *ngFor="let customerShipTo of customerShipToList" [value]="customerShipTo.shipToNumber">
                  {{ customerShipTo.shipToName }} ({{ customerShipTo.shipToNumber }})
                </ng-option>
              </ng-select>
            </div>
          </div>
          <!-- Shipto for internal users -->

          <div class="row py-2" *ngIf="!preSelectedBillToCustomer">
            <div class="col-5 col-lg-4">
              <label class="my-auto d-flex">
                SELECT CUSTOMER (BILL TO) <span class="text-danger">*</span>
                <mat-icon (click)="addNewCustomer() && open(content)"> add_circle_outline</mat-icon>
              </label>
            </div>
            <div *ngIf="!isGenericQuotesOnlyTF" class="col-7 col-lg-8">
              <pos-app-lib-customer-search
                #customerSearch
                [disabled]="isLoading$ | async"
                [forOrderSearch]="true"
                [selectedCustomerName]="getCustomerName()"
                (selectNewCustomer)="selectShipToCustomer($event)"
                [removeCustomerAfterLoad]="false"
              ></pos-app-lib-customer-search>
            </div>
            <div *ngIf="isGenericQuotesOnlyTF" class="col-7 col-lg-8">
              <input class="form-control" [value]="selectedShipToCustomer?.customerName" readonly formControlName="shipToName" />
            </div>
          </div>
          <div class="row py-2" *ngIf="preSelectedBillToCustomer">
            <div class="offset-4 col-8 font-weight-bold text-right">CONTACT ARB TO CREATE MORE DELIVERY ADDRESSES</div>
          </div>
          <!-- BillTo for internal users -->
          <div class="row py-2" *ngIf="preSelectedBillToCustomer || selectedShipToCustomer">
            <div class="col-5 col-lg-4">
              <label class="my-auto d-flex"
                >SELECT CUSTOMER (SHIP TO)

                <mat-icon
                  *ngIf="shipToCustomerTypeForm.get('shipToCustomerSelection').value === 0"
                  (click)="addingNewShipToCustomer() && open(content)"
                >
                  add_circle_outline</mat-icon
                ></label
              >
            </div>
            <div class="col-7 col-lg-8">
              <div *ngIf="preSelectedBillToCustomer">
                <input
                  class="form-control"
                  [value]="preSelectedBillToCustomer.customerName + ' (' + preSelectedBillToCustomer.customerNumber + ')'"
                  disabled
                />
              </div>
              <div *ngIf="!preSelectedBillToCustomer && selectedShipToCustomer && !isShipTo">
                <div *ngIf="selectedShipToCustomer?.customerType === 'BILLTO'" class="row">
                  <form [formGroup]="shipToCustomerTypeForm" class="col-3 col-lg-4">
                    <ng-select formControlName="shipToCustomerSelection" [clearable]="false" (change)="onShipToNumberChange($event)">
                      <ng-option [value]="0"> <label>Specified Ship To Customer</label> </ng-option>
                      <ng-option [value]="1"> <label>One-Off Ship To Customer</label> </ng-option>
                    </ng-select>
                  </form>
                  <div *ngIf="shipToCustomerTypeForm.get('shipToCustomerSelection').value === 0" class="col-3 col-lg-8">
                    <ng-select formControlName="shipToNumber" [clearable]="false">
                      <ng-option *ngFor="let customerShipTo of customerShipToList" [value]="customerShipTo.shipToNumber">
                        {{ customerShipTo.shipToName }} ({{ customerShipTo.shipToNumber }})
                      </ng-option>
                    </ng-select>
                  </div>
                  <div *ngIf="shipToCustomerTypeForm.get('shipToCustomerSelection').value === 1" class="col-3 col-lg-8">
                    <pos-app-lib-customer-ship-to-search
                      #shipToSearch
                      (selectNewShipToCustomer)="selectOneOffCustomer($event)"
                      removeCustomerAfterLoad="false"
                    >
                    </pos-app-lib-customer-ship-to-search>
                  </div>
                </div>

                <div *ngIf="selectedShipToCustomer?.customerType !== 'BILLTO'">
                  <input
                    class="form-control"
                    [value]="
                      startOrderForm.controls.shipToName.value
                        ? startOrderForm.controls.shipToName.value + ' (' + startOrderForm.controls.shipToNumber.value + ')'
                        : ''
                    "
                    disabled
                  />
                </div>
              </div>
              <div *ngIf="!preSelectedBillToCustomer && isShipTo && customerBillToList?.length > 0">
                <ng-select formControlName="customerNumber">
                  <ng-option *ngFor="let customerBillTo of customerBillToList" [value]="customerBillTo.billToNumber">
                    {{ customerBillTo.billToName }} ({{ customerBillTo.billToNumber }})
                  </ng-option>
                </ng-select>
              </div>
              <div *ngIf="!preSelectedBillToCustomer && isShipTo && customerBillToList?.length === 0">
                <pos-app-lib-customer-search
                  [forOrderSearch]="true"
                  [customerType]="'billto'"
                  (selectNewCustomer)="selectBillToCustomer($event)"
                  [selectedCustomerName]="selectedBillToCustomer?.customerName"
                ></pos-app-lib-customer-search>
              </div>
            </div>
          </div>
          <div class="row py-2">
            <div class="col-5 col-lg-4">
              <label>ORDER TYPE <span class="text-danger">*</span></label>
            </div>
            <div class="col-7 col-lg-8">
              <ng-select formControlName="orderType" [clearable]="false">
                <ng-option
                  *ngFor="let orderType of startOrderForm.controls.onBehalf.value === '0' ? orderTypes : nonCorpOrderTypes"
                  [value]="orderType.OrderTypeCode"
                >
                  {{ orderType.OrderTypeDescription }}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="row text-danger" *ngIf="startOrderForm.controls.orderType.errors?.invalidNonCorp">
            <div class="offset-5 col-7 offset-lg-4 col-lg-8">Selected order type is not valid for Non-corp store</div>
          </div>
          <div class="row text-danger" *ngIf="startOrderForm.controls.orderType.errors?.invalidOrderType">
            <div class="offset-5 col-7 offset-lg-4 col-lg-8">Cannot process a credit without a register connected</div>
          </div>
          <div class="row py-2">
            <div class="col-5 col-lg-4">
              <label>
                VEHICLE<span
                  class="pl-2 text-danger"
                  (click)="clearVehicle()"
                  *ngIf="selectedCustomerVehicle || vehicleDescription()?.trim().length > 0"
                >
                  (Clear)
                </span>
              </label>
            </div>
            <div class="col-7 col-lg-8">
              <input type="search" class="form-control" [value]="vehicleDescription()" readonly />
            </div>
          </div>
          <div class="row py-2">
            <div class="offset-3 col-9 offset-lg-4 col-lg-8 justify-content-end d-flex">
              <button
                *ngIf="preSelectedVehicle || (activeOrderVehicle$ | async) as selectedVehicle"
                type="button"
                class="btn btn-secondary text-white"
                (click)="getSelectedVehicle(selectedVehicle) && open(content)"
                [disabled]="
                  startOrderForm.controls.customerNumber.value === '' ||
                  !preSelectedVehicle ||
                  (loadingCustomerDetails$ | async) ||
                  (loadingLookupLists$ | async)
                "
              >
                USE VEHICLE FROM CATALOGUE
              </button>
              <span class="px-2"></span>
              <button
                type="button"
                class="btn btn-secondary text-white"
                (click)="open(content)"
                [disabled]="startOrderForm.controls.customerNumber.value === '' || (loadingLookupLists$ | async) || (loadingCustomerDetails$ | async)"
              >
                SELECT FROM GARAGE
              </button>
            </div>
          </div>
          <div class="row py-2">
            <div class="col-5 col-lg-4">
              <label
                >{{
                  userRole === USER_ROLE.external && startOrderForm.controls.orderType.value === ORDER_TYPE.quoteOrder
                    ? 'CUSTOMER DETAILS'
                    : 'ORDER REFERENCE'
                }}
                <span *ngIf="isOrderReferenceRequired" style="color: red">*</span></label
              >
            </div>
            <div class="col-7 col-lg-8 form-control-wrapper">
              <input
                class="form-control"
                formControlName="reference"
                maxlength="25"
                [ngClass]="{
                  'is-invalid':
                    isOrderReferenceRequired ||
                    (startOrderForm.get('reference').invalid && (startOrderForm.get('reference').dirty || startOrderForm.get('reference').touched))
                }"
              />
            </div>
          </div>
          <!-- TODO handle show user -->
          <div class="row py-2" *ngIf="userRole === USER_ROLE.showExternal || userRole === USER_ROLE.showInternal">
            <div class="col-5 col-lg-4">
              <label>RAISE ORDER ON BEHALF OF</label>
            </div>
            <div class="col-7 col-lg-8">
              <input type="radio" formControlName="onBehalf" value="0" /><span class="px-1"></span>ARB BRANCH
              <span class="px-2"></span>
              <input type="radio" formControlName="onBehalf" value="1" /><span class="px-1"></span>NON-CORPORATE STORE
            </div>
          </div>
          <div
            class="row py-2"
            [ngClass]="{
              'd-none': startOrderForm.controls.onBehalf.value !== '0'
            }"
          >
            <div class="col-5 col-lg-4">
              <label>BRANCH <span class="text-danger">*</span></label>
            </div>
            <div class="col-7 col-lg-8">
              <ng-select formControlName="dispatchFrom">
                <ng-option *ngFor="let branch of branchList" [value]="branch.BranchCode">
                  <span class="pr-1" *ngIf="branch.BranchCode">{{ branch.BranchCode }} -</span>
                  {{ branch.BranchDescription }}
                </ng-option>
                <ng-template ng-label-tmp let-item="item">
                  {{ item | branch : branchList }}
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div
            class="row py-2"
            [ngClass]="{
              'd-none': startOrderForm.controls.onBehalf.value !== '1'
            }"
          >
            <div class="col-5 col-lg-4">
              <label>NON-CORPORATE STORE</label>
            </div>
            <div class="col-7 col-lg-8">
              <ng-select formControlName="nonCorpStore">
                <ng-option *ngFor="let store of nonCorpStores" [value]="store">
                  {{ store.customerName }} - {{ store.address1 }}, {{ store.suburb }}, {{ store.postCode }}, {{ store.state }}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="row py-2" *ngIf="preSelectedBillToCustomer">
            <div class="offset-4 col-8 font-weight-bold text-right">CONTACT ARB TO SHIP FROM A DIFFERENT LOCATION</div>
          </div>
        </div>
        <div class="d-flex justify-content-end my-4">
          <button type="submit" (click)="createOrderConfirm()" class="btn text-white" [disabled]="invalid || (loadingCustomerDetails$ | async)">
            CREATE ORDER AND GO TO CATALOGUE
          </button>
          <span class="px-4"></span>
          <button type="submit" (click)="createOrderConfirm(true)" class="btn text-white" [disabled]="invalid || (loadingCustomerDetails$ | async)">
            CREATE ORDER AND GO TO ORDER
          </button>
          <span class="px-4"></span>
          <button type="button" class="btn btn-cancel" (click)="cancel()">CANCEL</button>
        </div>
      </form>
    </div>
  </div>
</div>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="arb-large-heading" id="modal-basic-title">
      {{
        isAddingVehicle
          ? 'NEW VEHICLE DETAILS'
          : isAddingCustomer
          ? 'NEW CUSTOMER DETAILS'
          : isAddingShipTo
          ? 'NEW SHIP TO'
          : isSelectingVehicle
          ? 'SELECT VEHICLE'
          : 'CUSTOMER VEHICLE SEARCH'
      }}
    </h3>
  </div>
  <div class="modal-body">
    <app-customers-vehicles
      *ngIf="!isSelectingVehicle && !isAddingVehicle && !isAddingCustomer && !isAddingShipTo"
      [customerNumber]="selectedShipToCustomer?.customerNumber || preSelectedBillToCustomer?.customerNumber"
      [currentCustomerVehicleId]="selectedCustomerVehicle?.customerVehicleId"
      (selectVehicleEvent)="selectCustomerVehicle($event)"
      (closeActiveModal)="d('Cross click')"
      [isAddVehicleForGenericCustomer]="this.selectedShipToCustomer?.genericVehiclesOnlyTF"
    ></app-customers-vehicles>
    <div *ngIf="isAddingVehicle">
      <app-customers-vehicles-details-new
        [currentCustomer]="this.selectedShipToCustomer.customerNumber"
        [preselectedVehicle]="selectedVehicle"
        (vehicleAdded)="closeAddingVehicle($event)"
        (cancelAdd)="closeAddingVehicle()"
        [isAddVehicleForGenericCustomer]="this.selectedShipToCustomer?.genericVehiclesOnlyTF"
      ></app-customers-vehicles-details-new>
    </div>
    <div *ngIf="isAddingCustomer">
      <app-customers-details-new (newCustomer)="handleNewCustomer($event)" [isForNewOrder]="true"></app-customers-details-new>
    </div>
    <div *ngIf="isAddingShipTo">
      <app-customers-ship-to-form
        (formChanged)="formValue = $event"
        (formIsValid)="formValid = $event"
        (formIsDirty)="formDirtyHandler($event)"
        [soldToCustomer]="selectedCustomerDetails$ | async"
        [lookupLists]="lookupLists$ | async"
        (submitByEnter)="(formValid)"
        (cancelled)="cancel()"
        (selectedCountry)="getFilteredStateList($event)"
        [filteredStateList]="filteredStateList"
        [disabledDefaultBillto]="true"
        [allCombinedBranchesList]="allCombinedBranchesList"
      >
      </app-customers-ship-to-form>
      <div class="d-flex float-end">
        <button class="col-sm-6 btn btn-cancel m-2" (click)="handleCloseModal()">CANCEL</button>
        <button class="col-sm-4 btn text-white my-2" (click)="saveShipTo()" [disabled]="!formValid">SAVE</button>
      </div>
    </div>
    <div *ngIf="isSelectingVehicle && !isAddingVehicle && !isAddingShipTo && !isAddingCustomer">
      <app-vehicles-selection (cancelSelect)="d('Cross click')" (submitCar)="onSelectVehicle($event)"></app-vehicles-selection>
    </div>
  </div>
</ng-template>
